import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import "./ReportsPage.css";
// import { FaDownload } from "react-icons/fa";

// Flatten one-level deep objects for CSV export
const flattenObject = (obj, parentKey = "") => {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = parentKey ? `${parentKey}_${key}` : key;
    if (obj[key] && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
      Object.assign(acc, flattenObject(obj[key], newKey));
    } else {
      acc[newKey] = obj[key];
    }
    return acc;
  }, {});
};

const ReportsPage = () => {
  const [sport, setSport] = useState("");
  const [type, setType] = useState("");
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gender, setGender] = useState("");
  const [city, setCity] = useState("");
  const tableWrapperRef = useRef(null);

  useEffect(() => {
    const prev = document.documentElement.style.overflowX;
    document.documentElement.style.overflowX = "hidden";
    return () => {
      document.documentElement.style.overflowX = prev || "";
    };
  }, []);

  useEffect(() => {
    if (tableWrapperRef.current) {
      setTimeout(() => {
        tableWrapperRef.current.scrollLeft = 0;
      }, 0);
    }
  }, [reports]);

  const fetchReports = async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://node.aattumtpl.com/api/reports", {
        params: {
          sport,
          type,
          genderCategory: gender || undefined,
          city: city || undefined, // ✅ send city filter if selected
          t: Date.now(),
        },
      });

      const flatData = (res.data || []).map((r) => flattenObject(r));
      console.log("Fetched Reports:", flatData);
      setReports(flatData);
    } catch (err) {
      console.error(err);
      setReports([]);
    } finally {
      setLoading(false);
    }
  };



  const csvSafeValue = (val) => {
    if (Array.isArray(val)) {
      return `"${val
        .map((v) =>
          typeof v === "object" && v !== null ? Object.values(v).join(" | ") : v
        )
        .join("; ")}"`;
    } else if (typeof val === "object" && val !== null) {
      return `"${Object.values(val).join(" | ")}"`;
    }
    return `"${val ?? ""}"`;
  };

  const downloadRowCSV = (row, index) => {
    const headers = Object.keys(row);
    const csvRows = [
      headers.join(","),
      headers.map((field) => csvSafeValue(row[field])).join(","),
    ];
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `report_row_${index + 1}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const downloadAllCSV = () => {
    if (!reports.length) return;
    const headers = Object.keys(reports[0]);
    const csvRows = [
      headers.join(","),
      ...reports.map((row) =>
        headers.map((field) => csvSafeValue(row[field])).join(",")
      ),
    ];
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${sport || "all"}_${type || "all"}_report.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>

      <div className="reports-container-lr">
        <h2 className="reports-title-lr">Sport Reports</h2>
        <p>
          View and analyze sports registrations, teams, and individual players. Use filters and reports to track performance and generate actionable insights.
        </p>
        {/* Filters */}
        <div className="filters-lr">
          <div className="row">
            <select
              value={sport}
              onChange={(e) => setSport(e.target.value)}
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                backgroundImage:
                  "url(\"data:image/svg+xml;utf8,<svg fill='%23222' height='14' viewBox='0 0 24 24' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 8px center",
                backgroundSize: "14px",
                paddingRight: "24px",
              }}
            >
              <option value="">Select Sport</option>
              <option value="basketball">Basketball</option>
              <option value="cricket">Cricket</option>
              <option value="football">Football</option>
              <option value="hockey">Hockey</option>
              <option value="kabaddi">Kabaddi</option>
              <option value="volleyball">Volleyball</option>
            </select>

            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                backgroundImage:
                  "url(\"data:image/svg+xml;utf8,<svg fill='%23222' height='14' viewBox='0 0 24 24' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 8px center",
                backgroundSize: "14px",
                paddingRight: "24px",
              }}
            >
              <option value="">Select Type</option>
              <option value="team">Team</option>
              <option value="individual">Individual</option>
            </select>

            <select
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              style={{
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
                backgroundImage:
                  "url(\"data:image/svg+xml;utf8,<svg fill='%23222' height='14' viewBox='0 0 24 24' width='14' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\")",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 8px center",
                backgroundSize: "14px",
                paddingRight: "24px",
              }}
            >
              <option value="">All Gender</option>
              <option value="Men">Men</option>
              <option value="Women">Women</option>
            </select>

            <input
              type="text"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              placeholder="Search city"
            />
          </div>


          <div className="row">
            <button onClick={fetchReports}>Get Reports</button>
            <button
              className="download-btn-lr"
              onClick={downloadAllCSV}
              disabled={!reports.length}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              <span>Download All</span>
            </button>


          </div>
        </div>

        {/* Results */}
        <div className="report-results-lr">
          {loading ? (
            <p className="loading-lr">Loading reports...</p>
          ) : reports.length === 0 ? (
            <p className="no-data-lr">No records found</p>
          ) : (
            <div className="table-wrapper-lr" ref={tableWrapperRef}>
              <table className="report-table-lr" role="table">
                <thead>
                  <tr>
                    {Object.keys(reports[0]).map((key, idx) => (
                      <th key={idx}>{key}</th>
                    ))}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {reports.map((row, idx) => (
                    <tr key={idx}>
                      {Object.keys(row).map((key, i) => {
                        const value = row[key];
                        let displayValue;

                        if (Array.isArray(value)) {
                          displayValue = (
                            <div className="nested-container">
                              {value.map((item, ri) => (
                                <div key={ri} className="nested-item">
                                  {Object.values(item).join(" — ")}
                                </div>
                              ))}
                            </div>
                          );
                        } else if (typeof value === "object" && value !== null) {
                          displayValue = (
                            <div className="nested-container">
                              {Object.entries(value).map(([k, v], i) => (
                                <div key={i} className="nested-item">
                                  <strong>{k}:</strong> {String(v)}
                                </div>
                              ))}
                            </div>
                          );
                        } else {
                          displayValue = String(value ?? "");
                        }

                        return <td key={i}>{displayValue}</td>;
                      })}
                      <td>
                        <button
                          className="row-download-btn-lr"
                          onClick={() => downloadRowCSV(row, idx)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                          </svg>
                        </button>


                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReportsPage;
